import { onDevicesChanged } from '@wix/live-video-commons';
import { useEffect, useState } from 'react';
export const useMediaPermissions = () => {
    const [hasPermissions, setHasPermissions] = useState(false);
    const [permissionsDenied, setPermissionsDenied] = useState(false);
    const [devices, setDevices] = useState({ cameras: [], microphones: [], speakers: [] });
    useEffect(() => {
        if (hasPermissions) {
            return onDevicesChanged(setDevices);
        }
        else {
            setDevices({ cameras: [], microphones: [], speakers: [] });
            return () => null;
        }
    }, [hasPermissions]);
    const requestPermissions = () => {
        try {
            navigator.mediaDevices
                .getUserMedia({ audio: true, video: true })
                .then(userMedia => {
                userMedia.getTracks().forEach(track => track.stop());
                setHasPermissions(true);
                setPermissionsDenied(false);
            })
                .catch(() => {
                setHasPermissions(false);
                setPermissionsDenied(true);
            });
        }
        catch (e) {
            setHasPermissions(false);
            setPermissionsDenied(true);
        }
    };
    return {
        hasPermissions,
        requestPermissions,
        permissionsDenied,
        devices,
    };
};
//# sourceMappingURL=media-permissions.js.map